<template>
<BaseDialog
        :showDialog="showGemaAvRegistrationDialog"
        maxDialogWidth="750"
        maxCardHeight="800"
        headline="lang_PUBLISHING_SHEETS_AV_REGISTRATION_DIALOG_HEADLINE"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <span>{{ dialogText }}</span>
                    </v-col>
                    <v-col cols="12" v-if="reportLink">
                        <a :href="reportLink" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid >
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <span v-if="gemaProgress" class="pr-3">
                            <v-progress-circular 
                                size="16"
                                width="2"
                                color="dialogProgressbar"
                                indeterminate
                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-remove-se'" 
                            ></v-progress-circular>
                        </span>
                        <span>
                            <BaseButton 
                                label="lang_PUBLISHING_WORKS_WORK_REGISTRATION_CAPTION_SEND"
                                @click="send"
                                :disabled="isLoading || allowSend === false"
                                :alvqa="alvqa+'-button-send'"
                            />
                        </span>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
  
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'


export default {
    name:'GemaAvRegistrationDialog',
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageDropdown,
    },
    data() {
        return {
            context: "GemaAvRegistration",
            alvqa: 'publishing-sheets-list-dialog-gema-av-registration'
        }
    },
    computed: {
        showGemaAvRegistrationDialog: {
            get() { return this.$store.getters.getShowGemaAvRegistrationDialog },
            set(show) { this.$store.commit('setShowGemaAvRegistrationDialog', show) }
        },
        reportLink:{ 
            get() { return this.$store.getters.getGemaAvRegistrationDialogReportLink },
            set(link) { this.$store.commit('setGemaAvRegistrationDialogReportLink', link)}
        },
        dialogText(){ 
            let dialogText = this.$store.getters.getGemaAvRegistrationDialogText
            if(dialogText.includes('lang')){
                return this.$t(dialogText);
            }  
            return dialogText;
        },
        isLoading(){ return this.$store.getters.getIsLoading },
        allowSend(){ return this.$store.getters.getGemaAvRegistrationDialogAllowSend },
        gemaProgress(){ return this.$store.getters.getIsLoading }
    },

    methods: {
        closeDialog() {
            this.showGemaAvRegistrationDialog = false
            this.reportLink = null
            this.$store.commit('setGemaAvRegistrationDialogText', 'lang_PUBLISHING_SHEETS_AV_REGISTRATION_DIALOG_TEXT_DEFAULT')
        },
        send() {
            this.$store.dispatch('createAvGemaJson', 'sendJson')
        },
    },
}
</script>

<style>

</style>